var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"pt-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8",domProps:{"innerHTML":_vm._s(_vm.$t('privacyverklaring-content'))}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }